import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { SectionHeader } from 'components/molecules';

const Welcome = props => {
  const { className, ...rest } = props;

  return (
    <div className={clsx('jarallax', className)} {...rest}>
      <SectionHeader
        title="We craft beautiful websites and digital products."
        titleVariant="h2"
        subtitle="We design, develop and launch websites and products for startups, companies and ourselves."
        ctaGroup={[
          <Button variant="contained" color="primary" size="large">
            Contact us
          </Button>,
        ]}
        disableGutter
        data-aos="fade-up"
      />
    </div>
  );
};

Welcome.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Welcome;
